import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen, IsXsScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const SecuritySettingsHelp = () => {
  const isMdScreen = IsMdScreen();
  const paddingValue = IsXsScreen() ? 1 : 3;

  return (
    <>
      <Stack padding={paddingValue} direction={"row"}>
        <ShContainer maxWidth='xl' margin='auto'>
          <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
            Security Settings
          </ResourceTypography>
          <ResourceTypography variant="body1" paragraph>
            Manage your account security settings to protect sensitive information and ensure
            secure access to your hiring platform. Configure authentication methods and access controls.
          </ResourceTypography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Authentication
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Set up and manage authentication methods including password policies, two-factor
            authentication, and single sign-on options. Ensure secure access to your account.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Access Control
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Configure role-based access control to manage who can access different features
            and data. Define permissions for team members based on their roles.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Data Security
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Manage data security settings including encryption, data retention policies,
            and secure data handling procedures. Protect sensitive candidate information.
          </Typography>

          <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
            Audit Logs
          </ResourceTypography>
          <Typography variant="body1" paragraph>
            Monitor account activity through detailed audit logs. Track user actions,
            system changes, and security events to maintain accountability.
          </Typography>

          <Box paddingTop={2} paddingBottom={3}>
            <ShButton
              component={RouterLink}
              to="/employer/settings/account/security"
              color="primary"
              variant="contained"
            >
              Configure Security Settings
            </ShButton>
          </Box>
        </ShContainer>
        {!isMdScreen && <CommonQuestionSidebar />}
      </Stack>
    </>
  );
};

export default SecuritySettingsHelp; 